// src/pages/Schedule.jsx
import React from 'react';
import ScheduleCard from '../components/ScheduleCard';
import './Schedule.css';

const Schedule = () => {
  const schedules = [
    { name: 'CAPITAL DAY', open: '15:05', close: '17:05' },
    { name: 'SINDEVI NIGHT', open: '19:20', close: '20:20' },
    { name: 'MILAN NIGHT', open: '21:05', close: '22:25' },
    { name: 'MAIN BAZAAR', open: '21:50', close: '00:00' },
    { name: 'SINDEVI BAZAR', open: '10:40', close: '14:49' },
    { name: 'SUPREME DAY', open: '16:15', close: '17:15' },
    { name: 'SUPREME NIGHT', open: '20:25', close: '22:25' },
    { name: 'RAJDHANI NIGHT', open: '21:25', close: '23:25' },
    { name: 'NIGHT MARKET', open: '23:10', close: '00:00' },
    { name: 'TIME BAZAR', open: '13:10', close: '18:25' },
    { name: 'KALYAN', open: '16:13', close: '18:45' },
    { name: 'HONEY NIGHT', open: '20:25', close: '22:25' },
    { name: 'KALYAN NIGHT', open: '21:25', close: '22:25' },
    { name: 'GAME TEST', open: '15:30', close: '20:05' },
    { name: 'MADHUR DAY', open: '01:25', close: '14:45' },
  ];

  return (
    <div className="schedule-page">
      <div className="page-header">
        <h1>Game Schedules</h1>
      </div>
      
      <div className="schedules-container">
        {schedules.map((schedule, index) => (
          <ScheduleCard 
            key={index}
            name={schedule.name}
            openTime={schedule.open}
            closeTime={schedule.close}
          />
        ))}
      </div>
      
      <div className="test-section">
        <h3>GAME TEST 121</h3>
        {/* Add test game components here */}
      </div>
    </div>
  );
};

export default Schedule;